import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=4e522961&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=ts"
export * from "./SurveyForm.vue?vue&type=script&lang=ts"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=4e522961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e522961",
  null
  
)

export default component.exports